import { useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const initials = (name = "") => name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase() || "U";

export default function UserPill({ variant = "buyer" }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("mousedown", onDoc); document.removeEventListener("keydown", onKey); };
  }, [open]);

  if (!user) return null;
  const isGuest = user.is_guest;
  const avatarBg = variant === "seller" ? "#1A17E0" : "#E8823A";
  const displayName = user.name || (isGuest ? "Tamu" : "Pengguna");

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        data-testid="user-pill"
        onClick={() => setOpen((v) => !v)}
        aria-haspopup="menu"
        aria-expanded={open}
        style={{
          display: "flex", alignItems: "center", gap: 10, padding: "8px 18px 8px 8px",
          background: "#fff", border: "1px solid rgba(38,34,30,0.12)", borderRadius: 999,
          cursor: "pointer", fontFamily: "inherit",
        }}
      >
        <span style={{ width: 32, height: 32, borderRadius: "50%", background: avatarBg, color: "#fff", display: "grid", placeItems: "center", fontWeight: 700, fontSize: 12 }}>
          {initials(displayName)}
        </span>
        <span style={{ display: "flex", flexDirection: "column", lineHeight: 1.2, textAlign: "left" }}>
          <strong style={{ fontSize: 14, color: "#26221E" }}>{displayName}</strong>
          <span style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: "#9A9084", maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {isGuest ? "Mode Tamu · sesi sementara" : user.email}
          </span>
        </span>
        <span aria-hidden="true" style={{ fontSize: 11, color: "#6E6559", marginLeft: 2, transform: open ? "rotate(180deg)" : "none", transition: "transform 150ms" }}>▾</span>
      </button>

      {open && (
        <div
          role="menu"
          data-testid="user-pill-menu"
          style={{
            position: "absolute", right: 0, top: "calc(100% + 8px)", zIndex: 60,
            width: 260, background: "#fff", border: "1px solid rgba(38,34,30,0.12)",
            borderRadius: 12, boxShadow: "0 18px 44px rgba(38,34,30,0.16)", padding: 8,
          }}
        >
          <div style={{ padding: "10px 12px 12px", borderBottom: "1px solid rgba(38,34,30,0.08)" }}>
            <div style={{ fontFamily: "'Bitter', Georgia, serif", fontWeight: 800, fontSize: 15, color: "#26221E" }}>{displayName}</div>
            <div className="font-mono-c" style={{ fontSize: 11, color: "#6E6559", marginTop: 2 }}>{isGuest ? "guest@tamu · " : ""}{user.office_name}</div>
          </div>

          {isGuest && (
            <a
              href="/"
              data-testid="menu-back-landing"
              role="menuitem"
              style={{ display: "block", padding: "10px 12px", fontSize: 13, color: "#26221E", textDecoration: "none", borderRadius: 6 }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(38,34,30,0.06)")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              ← Kembali ke halaman utama
            </a>
          )}

          <button
            data-testid="menu-logout"
            role="menuitem"
            onClick={() => { setOpen(false); logout(); }}
            style={{
              width: "100%", textAlign: "left", padding: "10px 12px", marginTop: 4,
              background: "transparent", border: "none", cursor: "pointer",
              color: "#B3261E", fontWeight: 700, fontSize: 13, borderRadius: 6,
              fontFamily: "inherit",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(179,38,30,0.06)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
          >
            {isGuest ? "Akhiri Sesi Tamu" : "Keluar dari Cookingin"}
          </button>
        </div>
      )}
    </div>
  );
}
